import { ROLE_LABEL, ROLE_TINT } from "../../lib/team";

export default function TeamRoleBadge({ role, className = "" }) {
  const tint = ROLE_TINT[role] || ROLE_TINT.tech_assistant;
  return (
    <span
      data-testid={`team-role-badge-${role}`}
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${tint} ${className}`}
    >
      {ROLE_LABEL[role] || role}
    </span>
  );
}
